module.exports = __webpack_public_path__ + "img/PS5_logo.758e93c8.svg";